import { SocketRoomEvent } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';

export const UserSecurityEventType = {
    SessionTerminated: 'session-terminated',
    SessionsTerminatedAll: 'sessions-terminated-all',
    GrantRevoked: 'grant-revoked',
} as const;

export type UserSecurityRoomMessage =
    | SocketRoomEvent<typeof UserSecurityEventType.SessionTerminated, { sessionId: string }>
    | SocketRoomEvent<typeof UserSecurityEventType.SessionsTerminatedAll, { sessionIds: string[] }>
    | SocketRoomEvent<typeof UserSecurityEventType.GrantRevoked, { grantId: string }>;

export const UserSecuritySettingsRooms = {
    userSecurity: (userId: string): RoomKey<UserSecurityRoomMessage> => ({ key: `settings:security:user:${userId}` }),
};
